import { usePage } from '@inertiajs/react';
import { VideoLandingPage } from '@/components/public/VideoLandingPage';
import type { VideoLandingConfig } from '@/components/public/VideoLandingPage';

type PageProps = {
  videoProvider: 'youtube' | 'loom';
  videoId: string;
  [key: string]: unknown;
};

const TraLeSedute = () => {
  const { videoProvider, videoId } = usePage<PageProps>().props;

  const config: VideoLandingConfig = {
    pageTitle: "Il vuoto tra una seduta e l'altra — Emovia",
    badge: 'Per psicologi',
    headline: "Cosa succede tra una seduta e l\u2019altra?",
    lead: 'I momenti più importanti del percorso emergono spesso a metà settimana, non in seduta. Emovia li raccoglie, li organizza e te li consegna prima del prossimo colloquio.',
    videoProvider,
    videoId,
    videoTitle: "Emovia — come funziona",
    supportCopy:
      'Per capire come Emovia colma quel vuoto, guarda questo video di 3 minuti.',
    ctaLabel: 'Richiedi una demo gratuita',
    ctaLocation: 'landing_tra_le_sedute_cta',
  };

  return <VideoLandingPage config={config} />;
};

export default TraLeSedute;
